/**
 * Checks if a keydown event corresponds to developer / inspection shortcut
 */
export const isDeveloperShortcut = (e: KeyboardEvent): boolean => {
  const key = e.key ? e.key.toUpperCase() : "";
  const keyCode = e.keyCode || e.which;

  // F12 key
  if (key === "F12" || keyCode === 123) {
    return true;
  }

  const isCtrlOrCmd = e.ctrlKey || e.metaKey;

  if (isCtrlOrCmd) {
    // Ctrl + Shift + I (Inspect)
    // Ctrl + Shift + J (Console)
    // Ctrl + Shift + C (Inspect Element)
    // Ctrl + Shift + K (Firefox Console)
    if (e.shiftKey && (key === "I" || key === "J" || key === "C" || key === "K" || keyCode === 73 || keyCode === 74 || keyCode === 67 || keyCode === 75)) {
      return true;
    }

    // Ctrl + U (View Source)
    if (key === "U" || keyCode === 85) {
      return true;
    }

    // Ctrl + S (Save Page)
    if (key === "S" || keyCode === 83) {
      return true;
    }
  }

  return false;
};

/**
 * Global Right Click & Shortcut Blocker Setup
 */
export const initSecurityGuards = (): (() => void) => {
  const handleContextMenu = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (isDeveloperShortcut(e)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  const handleDragStart = (e: DragEvent) => {
    if (e.target && (e.target as HTMLElement).tagName === "IMG") {
      e.preventDefault();
    }
  };

  window.addEventListener("contextmenu", handleContextMenu, { capture: true });
  window.addEventListener("keydown", handleKeyDown, { capture: true });
  window.addEventListener("dragstart", handleDragStart, { capture: true });

  return () => {
    window.removeEventListener("contextmenu", handleContextMenu, { capture: true });
    window.removeEventListener("keydown", handleKeyDown, { capture: true });
    window.removeEventListener("dragstart", handleDragStart, { capture: true });
  };
};
